
export const TechnologySection = () => {
  const features = [
    {
      icon: 'ri-leaf-line',
      title: '100% Biodegradable',
      description: 'Protecting the environment with fully biodegradable materials free from microplastics'
    },
    {
      icon: 'ri-drop-line',
      title: 'Superior Absorbency',
      description: 'Marine nano fiber technology delivers 3x higher absorbency than conventional products'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Safe Ingredients',
      description: 'Natural materials without chemicals, safe and non-irritating to skin'
    },
    {
      icon: 'ri-recycle-line',
      title: 'Sustainability',
      description: 'Creating a sustainable future with renewable resources extracted from the ocean'
    }
  ];

  return (
    <section id="technology" className="py-20 bg-gradient-to-br from-blue-50 to-cyan-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Advanced Marine Biotechnology
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Leading innovation in sustainable biotechnology with our breakthrough marine nano fiber solutions
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Technology Image */}
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/7af0ac940cb13d8bf076334a14accdff.jpg"
              alt="Marine Biotechnology Research"
              className="rounded-2xl shadow-2xl object-cover w-full h-96"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent rounded-2xl"></div>
          </div>

          {/* Technology Description */}
          <div>
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Revolutionary Marine Biotechnology
              </h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-blue-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Proprietary Marine Extraction</h4>
                    <p className="text-gray-600">Advanced marine organism processing and biotechnology innovation</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-blue-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Sustainable Bio-Materials</h4>
                    <p className="text-gray-600">100% biodegradable raw materials with zero environmental impact</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-blue-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Superior Performance</h4>
                    <p className="text-gray-600">Enhanced functionality and safety beyond conventional alternatives</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-blue-600 text-xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
